import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getProvince = id => {
  return http.get(
    `${getBaseUrl()}/province/${id}`
  );
};

export const getProvinces = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/province`
    );
  }
  return http.get(
    `${getBaseUrl()}/province?${paginate}`
  );
};

export const updateProvince = data => {

  return http.put(
    `${getBaseUrl()}/province/${data.id}`,
    data
  );
};
export const submitProvince = data => {

  return http.post(
    `${getBaseUrl()}/province`,
    data
  );
};
